import { render, staticRenderFns } from "./lottery-prize.vue?vue&type=template&id=af54869e&scoped=true"
import script from "./lottery-prize.vue?vue&type=script&lang=js"
export * from "./lottery-prize.vue?vue&type=script&lang=js"
import style0 from "./lottery-prize.vue?vue&type=style&index=0&id=af54869e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af54869e",
  null
  
)

export default component.exports